import template from './needALoan.html';
import controller from './needALoan.controller';
import './needALoan.scss';

let needALoanComponent = {
  restrict: 'E',
  bindings: {
    serviceClosed: '<'
  },
  template,
  controller
};

export default needALoanComponent;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/needALoan/needALoan.component.js